import { CLASS_NAMES, TITLE, DESCRIPTION } from './Content-constants';

const ViewComponent = ({}) => (
  <>
    <div className={CLASS_NAMES.headerWrapper}>
      <p className={CLASS_NAMES.title}>{TITLE}</p>
      <p className={CLASS_NAMES.description}>{DESCRIPTION}</p>
    </div>
  </>
);

ViewComponent.displayName = 'Expired-Content-view';

export default ViewComponent;
